import React from 'react';

const ZeroDayMethodHeader = () => {
    return (
      <div className="relative overflow-hidden mb-8 bg-gradient-to-br from-dark-500 to-dark-600 rounded-2xl p-6 group transform-gpu hover:scale-[1.01] transition-medium border border-dark-400 hover:border-accent-purple/50 hover:shadow-glow">
        {/* Background elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute -top-20 -left-20 w-64 h-64 rounded-full bg-accent-purple blur-3xl opacity-10 group-hover:opacity-20 transition-medium"></div>
          <div className="absolute -bottom-20 -right-20 w-64 h-64 rounded-full bg-accent-pink blur-3xl opacity-10 group-hover:opacity-20 transition-medium"></div>
          
          {/* Encryption grid pattern */}
          <div className="absolute inset-0 opacity-5">
            {[...Array(20)].map((_, i) => (
              <div 
                key={i}
                className="absolute w-1 h-1 bg-white rounded-full"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animation: `pulse-slow ${3 + Math.random() * 5}s ease-in-out infinite`,
                  animationDelay: `${Math.random() * 3}s`
                }}
              ></div>
            ))}
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row items-center relative z-10">
          <div className="w-full md:w-3/5 mb-6 md:mb-0">
            <div className="text-sm font-medium text-accent-pink mb-2 flex items-center transform-gpu group-hover:translate-x-1 transition-medium">
              <i className="fas fa-crown mr-1 animate-pulse-slow"></i>
              PREMIUM EXCLUSIVE
            </div>
            <h2 className="text-3xl font-bold mb-3 group-hover:text-white transition-medium">
              Proprietary <span className="gradient-text animate-pulse-text">Zero-Day</span> Method
            </h2>
            <p className="text-gray-400 mb-6 text-sm max-w-xl group-hover:text-gray-300 transition-medium">
              Our advanced proprietary technique uses undisclosed zero-day exploits with a 78% success rate on vulnerable servers. This method is constantly updated to stay ahead of security patches.
            </p>
            
            <div className="flex flex-wrap gap-3">
              {[
                { icon: 'fa-shield-alt', text: 'Undetectable', color: 'accent-green' },
                { icon: 'fa-bolt', text: 'Fast Execution', color: 'accent-yellow' },
                { icon: 'fa-key', text: 'Full Access', color: 'accent-orange' },
                { icon: 'fa-sync-alt', text: 'Weekly Updates', color: 'accent-blue' }
              ].map((item, index) => (
                <div 
                  key={index}
                  className={`flex items-center px-3 py-1.5 bg-dark-400 rounded-lg text-xs transform-gpu hover:scale-105 transition-medium group/badge hover:bg-gradient-to-r hover:from-accent-${item.color} hover:to-dark-400`}
                >
                  <i className={`fas ${item.icon} text-accent-${item.color} mr-1.5 group-hover/badge:text-white transition-medium`}></i>
                  <span className="group-hover/badge:text-white transition-medium">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="w-full md:w-2/5 flex items-center justify-center relative">
            {/* Animated hexagon with floating effect */}
            <div className="w-48 h-48 relative animate-float transform-gpu group-hover:scale-110 transition-medium">
              {/* Outer ring */}
              <div 
                className="absolute inset-0 rounded-full border-4 border-accent-pink opacity-20 animate-spin-slow"
              ></div>
              
              {/* Middle ring */}
              <div 
                className="absolute inset-4 rounded-full border-2 border-accent-purple opacity-40 animate-spin-slow-reverse"
              ></div>
              
              {/* Inner hexagon */}
              <div className="absolute inset-8 flex items-center justify-center">
                <div 
                  className="w-20 h-20 bg-dark-500 rounded-xl transform rotate-45 relative gradient-border group-hover:shadow-glow transition-medium"
                >
                  <div className="absolute inset-0 flex items-center justify-center -rotate-45">
                    <i className="fas fa-mask text-accent-pink text-3xl group-hover:text-accent-purple transition-medium"></i>
                  </div>
                </div>
              </div>
              
              {/* Floating particles */}
              {[...Array(6)].map((_, i) => (
                <div 
                  key={i}
                  className="absolute w-2 h-2 rounded-full bg-accent-purple opacity-70"
                  style={{
                    left: `${Math.cos(i * 60 * Math.PI / 180) * 40 + 50}%`,
                    top: `${Math.sin(i * 60 * Math.PI / 180) * 40 + 50}%`,
                    animation: `pulse-slow ${2 + i * 0.5}s ease-in-out infinite`,
                    animationDelay: `${i * 0.2}s`
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
};

export default ZeroDayMethodHeader;